import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const leaseAPI = new API(BASE_URL);

class LeaseApplicationService {
  static fetchLeaseApplication = id => leaseAPI.get(urls.LEASE.REGISTRATION, id);

  // tenantACtion
  static leaseApplicationActionTenant = data => leaseAPI.post(urls.LEASE.TENANT_APPROVAL, data);

  // ownerACtion
  static leaseApplicationActionOwner = data => leaseAPI.post(urls.LEASE.OWNER_APPROVAL, data);

  static leaseApplicationActionOtherOwner = data => leaseAPI.post(urls.LEASE.OTHER_OWNER_APPROVAL, data);

  static leaseClosure = (id, params = { secondPartyApprovalRequired: false }) =>
    leaseAPI.post(`${urls.LEASE.CLOSURE}/${id}`, null, params);

  static leaseClosureTenant = data => leaseAPI.post(urls.LEASE.CLOSURE_TENANT, data);

  static leaseClosureOwner = data => leaseAPI.post(urls.LEASE.CLOSURE_OWNER, data);

  static leaseTerminationCourtOrder = (id, params) =>
    leaseAPI.post(`${urls.LEASE.TERMINATION_COURT}/${id}`, null, params);

  static leaseCancellation = (id, params) => leaseAPI.post(`${urls.LEASE.CANCELLATION}/${id}`, null, params);

  static leaseCancellationTenantApproval = data => leaseAPI.post(urls.LEASE.CANCELLATION_TENANT_APPROVAL, data);

  static leaseCancellationOwnerApproval = data => leaseAPI.post(urls.LEASE.CANCELLATION_OWNER_APPROVAL, data);
}

export default LeaseApplicationService;
